<template>
  <BaseModal name="ordersModal" :clickToClose="false" :shiftY="0.5" :adaptive="true" :minHeight="680" height="auto"
    :resizable="true" :width="1400" classes="bg-transparent shadow-none" @before-open="beforeOpen"
    @before-close="beforeClose">
    <div class="mx-auto position-relative" :style="{
      width:
        modalInfo.mode == 'create'
          ? '460px'
          : dataForModal.order_ext__is_owner
            ? '1280px'
            : '875px'
    }">
      <BaseLoader v-if="modalInfo.loading"></BaseLoader>
      <div class="bg-system-main-block position-relative" :style="modalInfo.mode !== 'edit' ? 'height: 721.09px' : ''">
        <!-- <BaseLoader v-if="isLoadWithoutClear"></BaseLoader> -->
        <div class="bg-system-secondary py-10 px-30 d-flex gap-30">
          <div class="d-flex justify-content-between flex-grow-1">
            <div class="d-flex justify-content-between align-items-start flex-grow-1">
              <div class="d-flex flex-column">
                <span v-if="modalInfo.mode == 'create'" class="fw-bold fsc-12">{{
                  dataLang['orders_model_edit__header_new'] }}</span>

                <span class="fsc-12" v-if="modalInfo.mode == 'edit'">{{ dataLang['orders_modal_title_text1'] }}:
                  <span class="fw-bold">{{ mainInfo.order_id }}</span>
                  <span class="fw-bold"> от
                    {{
                      $time(mainInfo.orders__created_at)
                        .utc(true)
                        .utcOffset(Number(userSetting.company__utc))
                        .format(`${userSetting.company__tempalte_date} HH:mm`)
                    }}</span></span>
                <span class="fsc-12" v-if="modalInfo.mode == 'edit'">{{ dataLang['orders_modal_title_text2'] }}:
                  <span class="fw-bold"> {{ mainInfo.ads__name }}</span></span>
              </div>
              <div class="d-flex gap-50">
                <span class="fsc-12" v-if="modalInfo.mode == 'edit'">{{ dataLang['orders_modal_title_text3'] }}
                  <span class="fw-bold"> {{ mainInfo.manager }}</span></span>
                <span class="fsc-12" v-if="modalInfo.mode == 'edit'">{{ dataLang['orders_modal_title_text4'] }}
                  <span class="fw-bold">
                    {{ dataLang[mainInfo.order_statuses__status] }}</span></span>
              </div>
            </div>
          </div>
          <button type="button" class="btn-close" @click="$modal.hide('ordersModal')"></button>
        </div>
        <div class="px-30 pt-10 pb-35">
          <div class="row gx-10 pb-10">
            <div class="" :class="[
              dataForModal.order_ext__is_owner && modalInfo.mode == 'edit'
                ? 'col-4'
                : modalInfo.mode == 'create'
                  ? 'col'
                  : 'col-6'
            ]">
              <div class="system-block position-relative" :class="{
                'is-overlay':
                  !dataForModal.order_ext__is_owner &&
                  modalInfo.mode == 'edit'
              }">
                <BaseLoader v-if="loadingsStateComponent.main"></BaseLoader>
                <div class="mb-10 fsc-12">
                  <span>{{
                    dataLang['orders-page__table__header_timer_text3']
                  }}</span>:
                  <span class="fw-bold">{{
                    dataLang[mainInfo.order_statuses__status]
                  }}</span>
                </div>
                <div>
                  <div class="d-flex justify-content-between align-items-center mb-10" ref="order_ext__ad_id">
                    <span class="fsc-11 text-muted input-title">{{
                      dataLang['orders_model_edit__ad_name']
                    }}</span>

                    <BaseSelect v-if="!modalInfo.loading" style="width: 250px" placeholder="" selectLabel=""
                      deselectLabel="" @input="
                        (data) =>
                          setSimpleSelect(
                            { value: data.ads__id },
                            'order_ext__ad_id'
                          )
                      " v-model="dataFromSelect.ads" :options="selectsOptions?.ads" label="ads__name">
                      <template slot="noOptions">{{
                        dataLang['select_empty']
                      }}</template>
                      <template slot="noResult">{{
                        dataLang['select_search_empty']
                      }}</template><template slot="selectedLabel">{{
                          dataLang['select_selected']
                        }}</template>
                      <template slot="deselectLabel">{{
                        dataLang['select_unselect']
                      }}</template>
                    </BaseSelect>
                  </div>
                  <div class="d-flex justify-content-between align-items-center mb-10" ref="orders__type_rent">
                    <span class="fsc-11 text-muted input-title">{{
                      dataLang['orders_model_edit__type_rent']
                    }}</span>

                    <BaseSelect v-if="!modalInfo.loading" style="width: 250px" placeholder="" selectLabel=""
                      deselectLabel="" @input="setSimpleSelect" v-model="dataFromSelect.orders__type_rent" label="label"
                      :options="selectsOptions.orders__type_rent">
                      <template slot="noOptions">{{
                        dataLang['select_empty']
                      }}</template>
                      <template slot="noResult">{{
                        dataLang['select_search_empty']
                      }}</template><template slot="selectedLabel">{{
                          dataLang['select_selected']
                        }}</template>
                      <template slot="deselectLabel">{{
                        dataLang['select_unselect']
                      }}</template>
                    </BaseSelect>
                  </div>
                  <div class="d-flex justify-content-between align-items-center mb-10" ref="orders__vehicle_type">
                    <span class="fsc-11 text-muted input-title">{{
                      dataLang['orders_model_edit__vehicle_type']
                    }}</span>

                    <BaseSelect v-if="!modalInfo.loading" style="width: 250px" placeholder="" selectLabel=""
                      deselectLabel="" @input="
                        (data) =>
                          setSimpleSelect(
                            {
                              value: data.vehicle_types__code,
                              fallback: data.vehicle_types__id
                            },
                            'orders__vehicle_type'
                          )
                      " v-model="dataFromSelect.objects_types" :custom-label="({ vehicle_types__code }) => {
                        return dataLang[vehicle_types__code]
                      }
                        " :options="selectsOptions.objects_types">
                      <template slot="noOptions">{{
                        dataLang['select_empty']
                      }}</template>
                      <template slot="noResult">{{
                        dataLang['select_search_empty']
                      }}</template><template slot="selectedLabel">{{
                          dataLang['select_selected']
                        }}</template>
                      <template slot="deselectLabel">{{
                        dataLang['select_unselect']
                      }}</template>
                    </BaseSelect>
                  </div>
                  <div class="d-flex justify-content-between align-items-center mb-10" ref="orders__body_generation">
                    <span class="fsc-11 text-muted input-title">{{
                      dataLang['orders_model_edit__body_generation']
                    }}</span>

                    <BaseSelect v-if="!modalInfo.loading" style="width: 250px" placeholder="" selectLabel=""
                      deselectLabel="" @input="
                        (data) =>
                          setSimpleSelect(
                            {
                              value:
                                data.vehicles_body_generation__body_generation
                            },
                            'orders__body_generation'
                          )
                      " v-model="dataFromSelect.orders__body_generation" :custom-label="({ vehicles_body_generation__body_generation }) => {
                        return dataLang[
                          vehicles_body_generation__body_generation
                        ]
                      }
                        " :options="selectsOptions?.car_body_type">
                      <template slot="noOptions">{{
                        dataLang['select_empty']
                      }}</template>
                      <template slot="noResult">{{
                        dataLang['select_search_empty']
                      }}</template><template slot="selectedLabel">{{
                          dataLang['select_selected']
                        }}</template>
                      <template slot="deselectLabel">{{
                        dataLang['select_unselect']
                      }}</template>
                    </BaseSelect>
                  </div>
                  <div class="d-flex justify-content-between align-items-center mb-10" ref="orders__start_city_id">
                    <span class="fsc-11 text-muted lh-1 input-title">{{
                      dataLang['orders_model_edit__start_city']
                    }}</span>
                    <div class="d-flex justify-content-between align-items-center">
                      <BaseSelect v-if="!modalInfo.loading" style="width: 184px" placeholder="" selectLabel=""
                        deselectLabel="" @input="
                          (data) => {
                            transUtc.orders__starts =
                              Number(data.cities__utc) >= 0
                                ? Number(data.cities__utc) * -1
                                : Number(data.cities__utc)
                            setSimpleSelect(
                              { value: data.cities__id },
                              'orders__start_city_id'
                            )
                          }
                        " v-model="dataFromSelect.cities__start_name" :custom-label="({ cities__name, cities__region }) => {
                          return `${cities__name}  ${cities__region ? '(' + cities__region + ')' : ''
                            }`
                        }
                          " :options="selectsOptions.cities">
                        <template slot="noOptions">{{
                          dataLang['select_empty']
                        }}</template>
                        <template slot="noResult">{{
                          dataLang['select_search_empty']
                        }}</template><template slot="selectedLabel">{{
                            dataLang['select_selected']
                          }}</template>
                        <template slot="deselectLabel">{{
                          dataLang['select_unselect']
                        }}</template>
                      </BaseSelect>
                      <BaseCheckboxV2 placeholder="" class="text-white ms-5" input-name="orders__delivery_start"
                        v-model="dataForModal.orders__delivery_start" @oncheckeds="updateValue">
                        <span class="text-muted">{{
                          dataLang['orders_model_edit__start_city_delivery']
                        }}</span>
                      </BaseCheckboxV2>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between align-items-center mb-10" ref="orders__end_city_id">
                    <span class="fsc-11 text-muted lh-1 input-title">{{
                      dataLang['orders_model_edit__end_city']
                    }}</span>
                    <div class="d-flex justify-content-between align-items-center">
                      <BaseSelect v-if="!modalInfo.loading" style="width: 184px" placeholder="" selectLabel=""
                        deselectLabel="" @input="
                          (data) => {
                            transUtc.orders__ends =
                              Number(data.cities__utc) >= 0
                                ? Number(data.cities__utc) * -1
                                : Number(data.cities__utc)
                            setSimpleSelect(
                              { value: data.cities__id },
                              'orders__end_city_id'
                            )
                          }
                        " v-model="dataFromSelect.cities__end_name" :custom-label="({ cities__name, cities__region }) => {
                          return `${cities__name}  ${cities__region ? '(' + cities__region + ')' : ''
                            }`
                        }
                          " :options="selectsOptions.cities">
                        <template slot="noOptions">{{
                          dataLang['select_empty']
                        }}</template>
                        <template slot="noResult">{{
                          dataLang['select_search_empty']
                        }}</template><template slot="selectedLabel">{{
                            dataLang['select_selected']
                          }}</template>
                        <template slot="deselectLabel">{{
                          dataLang['select_unselect']
                        }}</template>
                      </BaseSelect>
                      <BaseCheckboxV2 placeholder="" class="text-white ms-5" input-name="orders__delivery_end"
                        v-model="dataForModal.orders__delivery_end" @oncheckeds="updateValue">
                        <span class="text-muted">{{
                          dataLang['orders_model_edit__start_city_delivery']
                        }}</span>
                      </BaseCheckboxV2>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between align-items-center mb-10" ref="orders__starts">
                    <span class="fsc-11 text-muted input-title">{{
                      dataLang['orders-page__table__header_order_text10']
                    }}</span>
                    <BaseDatePicker :minute-step="15" v-model="dataForDatePicker.orders__starts" type="datetime"
                      class="fsc-11 idiots-class-for-input-date" lang="ru" style="width: 250px" :clearable="false"
                      :time-title-format="userSetting.company__tempalte_date" :disabled-date="notBeforeToday"
                      :format="`${userSetting.company__tempalte_date} HH:mm`"
                      @change="(date) => changeDate(date, 'orders__starts')">
                    </BaseDatePicker>
                  </div>
                  <div class="d-flex justify-content-between align-items-center mb-10" ref="orders__ends">
                    <span class="fsc-11 text-muted input-title">{{
                      dataLang['orders-page__table__header_order_text11']
                    }}</span>
                    <BaseDatePicker :minute-step="15" v-model="dataForDatePicker.orders__ends" type="datetime"
                      class="fsc-11 idiots-class-for-input-date" lang="ru" style="width: 250px" :clearable="false"
                      :time-title-format="userSetting.company__tempalte_date" :disabled-date="notBeforeStart"
                      :format="`${userSetting.company__tempalte_date} HH:mm`"
                      @change="(date) => changeDate(date, 'orders__ends')">
                    </BaseDatePicker>
                  </div>
                  <div class="d-flex align-items-center justify-content-between fsc-11 mb-10">
                    <span class="text-muted">{{
                      dataLang['orders_model_edit__text3']
                    }}</span>
                    <div class="border border-gray text-lowercase" style="width: 250px; padding: 2px; height: 26px">
                      {{ diffByDate }}
                    </div>
                  </div>
                  <div ref="orders__vehicle_name">
                    <BaseInputNew v-if="
                      modalInfo.mode == 'create' ||
                      dataForModal.order_ext__is_owner
                    " placeholder="" width="250" class="mb-10 lh-1 gap-20" input-name="orders__vehicle_name"
                      @input="updateValue" :horizontalTitle="true" signClass="" inputClass=""
                      :value="dataForModal.orders__vehicle_name" :additionalParams="{}"
                      :name-sign="dataLang['orders_model_edit__text4']">
                    </BaseInputNew>
                  </div>
                  <div ref="orders__before_cost">
                    <BaseInputNew v-if="
                      modalInfo.mode == 'create' ||
                      dataForModal.order_ext__is_owner
                    " placeholder="" width="250" class="lh-1 gap-15 mb-5" input-name="orders__before_cost"
                      @input="updateValue" :horizontalTitle="true" signClass="lh-1"
                      :value="dataForModal.orders__before_cost" :additionalParams="{}"
                      :name-sign="dataLang['orders_model_edit__text5']">
                    </BaseInputNew>
                  </div>
                  <div class="special-box py-5 mb-5" ref="orders__vehicle_id" v-if="modalInfo.mode == 'edit'">
                    <div class="position-relative d-flex gap-10 align-items-center">
                      <div class="d-flex gap-5 align-items-center">
                        <BaseInputNew placeholder="" width="50" class="" style="min-width: 169px"
                          input-name="orders__vehicle_id" @input="(data) => {
                            updatedValues.orders__vehicle_id = data.value
                            objectID = data.value
                          }" :horizontalTitle="true" signClass="d-flex text-white" :value="objectID"
                          :additionalParams="{}" name-sign="RIN">
                        </BaseInputNew>
                        <div style="
                            background: linear-gradient(
                              180deg,
                              rgba(93, 92, 92, 0.2) 19.38%,
                              rgba(215, 215, 215, 0.179815) 100%
                            );
                          " @click="() => loadCalculate(true)"
                          class="fsc-8 p-5 cursor-pointer rounded-5 specal-button">
                          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none"
                            style="margin: auto">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M4.87902 10.2427C2.20706 10.2427 0.0410156 8.06171 0.0410156 5.37134C0.0410156 2.68097 2.20706 0.5 4.87902 0.5C7.55098 0.5 9.71702 2.68097 9.71702 5.37134C9.71702 6.49706 9.33779 7.53359 8.70094 8.35849L11.9589 11.6389L11.1036 12.5L7.84569 9.21962C7.02645 9.86084 5.99702 10.2427 4.87902 10.2427ZM8.50752 5.37134C8.50752 7.38911 6.88299 9.02484 4.87902 9.02484C2.87505 9.02484 1.25052 7.38911 1.25052 5.37134C1.25052 3.35356 2.87505 1.71783 4.87902 1.71783C6.88299 1.71783 8.50752 3.35356 8.50752 5.37134Z"
                              fill="black" />
                          </svg>
                        </div>
                      </div>
                      <div class="fsc-11 text-white lh-1 flex-shrink-0 d-block" style="width: 100px" v-html="fullname">
                      </div>
                    </div>
                  </div>
                  <div class="py-5 mb-5 text-center text-white fsc-11" style="background-color: #23b14d"
                    v-if="modalInfo.mode !== 'edit'">
                    Прикрепить объект можно после создания заказа
                  </div>
                  <BaseInputNew placeholder="" width="250" class="lh-1 gap-15 mb-10 mt-5"
                    :class="{ 'd-none': modalInfo.mode == 'create' }" disabled input-name="orders__cost"
                    @input="updateValue" :horizontalTitle="true" signClass="lh-1" :value="finishCost"
                    :additionalParams="{}" :name-sign="dataLang['orders_model_edit__text7']">
                  </BaseInputNew>
                  <!-- v-if="modalInfo.mode == 'create' || dataForModal.order_ext__is_owner" -->
                  <div class="d-flex align-items-center gap-5 mb-10" v-if="
                    dataForModal.order_ext__is_owner ||
                    modalInfo.mode == 'create'
                  ">
                    <BaseInputNew
                      ref="phoneInput"
                      class="flex-grow-1" :style="{maxWidth: modalInfo.mode == 'edit' ? '233px' : 'auto'}"
                      :width="modalInfo.mode == 'edit' ? '115' : '250'"
                      input-name="clients__phone"
                      placeholder="+7(___)___-__-__"
                      :value="updatedValues.clients__phone || dataForModal.clients__phone"
                      @input="updateValue"
                      :horizontalTitle="true"
                      inputRef="clients__phone"
                      inputMask="+{7}(000)000-00-00"
                      :disabled="phoneLookupLoading"
                      maxLength="16"
                      :additionalParams="{}"
                      :name-sign="dataLang['orders_model_edit__text8']">
                      <template #label>
                        <span class="text-danger">*</span>
                      </template>
                    </BaseInputNew>
                    <div class="d-flex align-items-center gap-5" v-if="modalInfo.mode == 'edit'">
                      <div class="px-5 fsc-9 d-flex gap-5 align-items-center text-white rounded-5"
                        style="position: relative; z-index: 4" :class="[
                          dataForModal.verifications.yandexrent.status
                            ? 'bg-green'
                            : 'bg-disabled'
                        ]">
                        <svg v-if="dataForModal.verifications.yandexrent.status" xmlns="http://www.w3.org/2000/svg"
                          width="11" height="10" viewBox="0 0 11 10" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M9.87007 1.5348C10.0194 1.6457 10.0436 1.84797 9.92413 1.98659L4.38568 8.41515C4.32417 8.48654 4.23283 8.53023 4.13452 8.53529C4.03621 8.54035 3.94024 8.50629 3.87061 8.44164L1.10139 5.87021C0.966205 5.74469 0.966205 5.54117 1.10139 5.41565C1.23657 5.29012 1.45574 5.29012 1.59092 5.41565L4.08668 7.73313L9.38353 1.585C9.50296 1.44638 9.72079 1.42391 9.87007 1.5348Z"
                            fill="white" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        СБ-1 (S)
                      </div>
                      <div class="px-5 fsc-9 d-flex gap-5 align-items-center text-white rounded-5"
                        style="position: relative; z-index: 4" :class="[
                          dataForModal.verifications.company.status
                            ? 'bg-green'
                            : 'bg-disabled'
                        ]">
                        <svg v-if="dataForModal.verifications.company.status" xmlns="http://www.w3.org/2000/svg"
                          width="11" height="10" viewBox="0 0 11 10" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M9.87007 1.5348C10.0194 1.6457 10.0436 1.84797 9.92413 1.98659L4.38568 8.41515C4.32417 8.48654 4.23283 8.53023 4.13452 8.53529C4.03621 8.54035 3.94024 8.50629 3.87061 8.44164L1.10139 5.87021C0.966205 5.74469 0.966205 5.54117 1.10139 5.41565C1.23657 5.29012 1.45574 5.29012 1.59092 5.41565L4.08668 7.73313L9.38353 1.585C9.50296 1.44638 9.72079 1.42391 9.87007 1.5348Z"
                            fill="white" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        СБ-2 (Внут.)
                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-itmes-center gap-5 mb-10" v-if="
                    dataForModal.order_ext__is_owner ||
                    modalInfo.mode == 'create'
                  ">
                    <BaseInputNew placeholder="" width="250" input-name="clients__name" class="flex-grow-1"
                      @input="updateValue" :disabled="modalInfo.mode == 'edit'" :horizontalTitle="true"
                      :value="clientName" maxLenght="16" :additionalParams="{}"
                      :name-sign="dataLang['orders_model_edit__text9']">
                    </BaseInputNew>
                  </div>
                  <div v-if="modalInfo.mode == 'create'"
                    class="d-flex justify-content-between align-items-center mt-10">
                    <span class="fsc-11 text-muted">{{
                      dataLang['orders_modal_select_text111']
                    }}</span>
                    <BaseSelect v-if="!modalInfo.loading" style="width: 250px" placeholder="" selectLabel=""
                      deselectLabel="" @input="(data) => setSimpleSelect(data)" v-model="dataFromSelect.client"
                      label="label" :disabled="disableTypeClient" openDirection="top"
                      :options="selectsOptions.clients_types_face">
                      <template slot="noOptions">{{
                        dataLang['select_empty']
                      }}</template>
                      <template slot="noResult">{{
                        dataLang['select_search_empty']
                      }}</template><template slot="selectedLabel">{{
                          dataLang['select_selected']
                        }}</template>
                      <template slot="deselectLabel">{{
                        dataLang['select_unselect']
                      }}</template>
                    </BaseSelect>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4" :class="[
              dataForModal.order_ext__is_owner && modalInfo.mode == 'edit'
                ? 'col-4'
                : modalInfo.mode == 'create'
                  ? 'col'
                  : 'col-6'
            ]" v-if="modalInfo.mode == 'edit'">
              <div class="d-flex flex-column h-100">
                <div class="system-block mb-10 position-relative" v-if="
                  modalInfo.mode == 'edit' && dataForModal.order_ext__is_owner
                ">
                  <BaseLoader v-if="loadingsStateComponent.deferred"></BaseLoader>
                  <div class="d-flex justify-content-between align-items-center mb-10">
                    <span class="fsc-11 text-muted">{{
                      dataLang['orders_model_edit__text10']
                    }}</span>

                    <BaseSelect v-if="!modalInfo.loading" style="width: 225px" placeholder="" selectLabel=""
                      deselectLabel="" @input="(data) => (senderSmsPreset = data)" v-model="dataFromSelect.sms_presets"
                      :options="selectsOptions?.presets" label="sms_presets__name">
                      <template slot="noOptions">{{
                        dataLang['select_empty']
                      }}</template>
                      <template slot="noResult">{{
                        dataLang['select_search_empty']
                      }}</template><template slot="selectedLabel">{{
                          dataLang['select_selected']
                        }}</template>
                      <template slot="deselectLabel">{{
                        dataLang['select_unselect']
                      }}</template>
                    </BaseSelect>
                  </div>
                  <div class="d-flex justify-content-end">
                    <div class="base-button base-button--action" @click="sendSms">
                      <span class="fsc-11">{{
                        dataLang['orders_model_edit__btn_text7']
                      }}</span>
                    </div>
                  </div>
                  <div>
                    <span class="fsc-11 fw-bold">{{
                      dataLang['orders_model_edit__text12']
                    }}</span>
                    <div>
                      <span class="fsc-11 text-muted">{{
                        dataLang['orders_model_edit__text13']
                      }}</span>
                      <div class="d-flex gap-10 mt-10">
                        <div class="base-button base-button--action flex-grow-1" @click="orderDeferred('hour')">
                          <span class="fsc-11">{{
                            dataLang['orders_model_edit__btn_text1']
                          }}</span>
                        </div>
                        <div class="base-button base-button--action flex-grow-1" @click="orderDeferred('day')">
                          <span class="fsc-11">{{
                            dataLang['orders_model_edit__btn_text2']
                          }}</span>
                        </div>
                        <div class="base-button base-button--action flex-grow-1"
                          @click="$modal.show('selectDateForDeferredOrder')">
                          <span class="fsc-11">{{
                            dataLang['orders_model_edit__btn_text3']
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="bg-system-primary rounded-5 flex-grow-1">
                  <div
                    class="py-10 border-bottom border-white text-center text-uppercase text-primary fw-bold fsc-12 mb-10">
                    {{ dataLang['orders_model_edit__text14'] }}
                  </div>
                  <div class="text-center text-white fsc-12">
                    <p class="fw-bold text-uppercase">
                      {{ dataLang[dataForModal.action_data?.title] }}
                    </p>

                    <div class="d-flex gap-10 align-items-center px-5 text-uppercase"
                      v-if="dataForModal.action_data?.btns.length">
                      <div v-if="dataForModal.action_data?.btns[0]?.action"
                        v-for="(action, index) in dataForModal.action_data.btns" :key="index" @click="
                          sendData(
                            dataForModal.action_data?.btns[index]?.action
                          )
                          " class="btn flex-grow-1 fsc-14 py-15 text-uppercase text-white mb-10" :style="{
                            backgroundColor: index == 0 ? '#23b14d' : 'red'
                          }">
                        {{
                          dataLang[dataForModal.action_data?.btns[index]?.name]
                        }}
                      </div>
                      <div class="py-15 mb-10 bg-primary text-dark wp-100"
                        v-if="!dataForModal.action_data?.btns[0]?.action">
                        {{ dataLang[dataForModal.action_data?.btns[0]?.name] }}
                      </div>
                    </div>
                    <p class="px-5 text-start" v-html="dataLang[dataForModal.action_data?.description]"></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4" :class="[
              dataForModal.order_ext__is_owner && modalInfo.mode == 'edit'
                ? 'col-4'
                : modalInfo.mode == 'create'
                  ? 'col'
                  : 'col-6'
            ]" v-if="
              modalInfo.mode == 'edit' && dataForModal.order_ext__is_owner
            ">
              <div class="system-block h-100 position-relative">
                <BaseLoader v-if="loadingsStateComponent.comment"></BaseLoader>
                <span class="fsc-11 fw-bold">{{
                  dataLang['vehicles_page__modal__tab_comments__name']
                }}</span>
                <div class="d-flex gap-10 mt-15 mb-10">
                  <BaseInputNew placeholder="" width="100%" class="wp-100" input-name="newComment"
                    @input="(data) => (newCommentValue = data)" :horizontalTitle="true" ref="commentInput" value=""
                    :additionalParams="{}" name-sign="">
                  </BaseInputNew>
                  <div class="base-button base-button--action px-5 py-5" style="min-height: 26px; height: 26px"
                    @click="sendComment">
                    <img :src="require(`@/assets/icons/add.svg`)" width="12" height="12" />
                  </div>
                </div>
                <BaseScrollbar style="max-height: 470px">
                  <div class="comments">
                    <div class="comments-base d-flex flex-column gap-10">
                      <div v-for="(comment, index) of commentsList" :key="comment.order_comments__id"
                        class="comment d-flex gap-5 justify-content-between border border-1 border-disabled">
                        <div class="comment-info d-flex flex-column gap-0">
                          <p class="comment-info__heading text-black fw-normal fsc-11 lh-sm m-0">
                            {{
                              $time(comment.order_comments__created_at)
                                .utc(true)
                                .utcOffset(Number(userSetting.company__utc))
                                .format(
                                  `${userSetting.company__tempalte_date} HH:mm`
                                )
                            }}
                            {{ comment.employees__name }}
                          </p>
                          <p class="comment-info__content text-black fw-medium fsc-12 lh-sm m-0">
                            {{ comment.order_comments__comment }}
                          </p>
                        </div>

                        <div class="comment-actions d-flex h-100">
                          <div :class="[
                            comment.order_comments__fixed
                              ? 'comment-actions__pin--active'
                              : ''
                          ]"
                            class="comment-actions__pin d-flex justify-content-center align-items-center rounded-5 cursor-pointer"
                            @click="
                              () => {
                                fixComment(
                                  comment.order_comments__id,
                                  !comment.order_comments__fixed
                                )
                                comment.order_comments__fixed =
                                  !comment.order_comments__fixed
                              }
                            ">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                              fill="none">
                              <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M13.1206 4.24668C13.2769 4.40289 13.2769 4.65616 13.1206 4.81236L12.727 5.20601C12.5708 5.36222 12.3175 5.36222 12.1613 5.20601L10.7942 3.83889C10.638 3.68268 10.638 3.42942 10.7942 3.27321L11.1878 2.87956C11.344 2.72335 11.5973 2.72335 11.7535 2.87956L13.1206 4.24668ZM13.4506 5.42578C13.6849 5.19119 14.065 5.19106 14.2994 5.42548L14.5476 5.67366C14.7066 5.8326 14.7066 6.09031 14.5476 6.24926L12.2452 8.55166C12.0863 8.71061 11.8286 8.71061 11.6696 8.55166L11.094 7.97606C11.041 7.92307 10.9551 7.92307 10.9021 7.97606L10.6567 8.2215C10.5741 8.30409 10.5536 8.43025 10.6059 8.53472L11.3466 10.0161C11.4249 10.1728 11.3942 10.362 11.2703 10.4859L9.36721 12.389C9.20827 12.5479 8.95056 12.5479 8.79161 12.389L6.68108 10.2785L2.41204 14.5475C2.25309 14.7064 1.99539 14.7064 1.83644 14.5475L1.45271 14.1638C1.29376 14.0048 1.29376 13.7471 1.45271 13.5882L5.72174 9.31913L3.61121 7.20859C3.45226 7.04964 3.45226 6.79194 3.61121 6.63299L5.51431 4.72989C5.63819 4.60601 5.82744 4.5753 5.98413 4.65365L7.46549 5.39433C7.56995 5.44656 7.69612 5.42608 7.7787 5.3435L8.02415 5.09805C8.07713 5.04507 8.07713 4.95917 8.02415 4.90619L7.44855 4.33059C7.2896 4.17164 7.2896 3.91393 7.44855 3.75499L9.75095 1.45258C9.9099 1.29364 10.1676 1.29364 10.3265 1.45258L10.5747 1.70076C10.8091 1.93518 10.809 2.31531 10.5744 2.54958L9.27128 3.85092C9.16532 3.95689 9.16532 4.12869 9.27128 4.23465L9.84688 4.81025C9.95285 4.91622 9.95285 5.08802 9.84688 5.19399L7.83228 7.20859C7.72631 7.31456 7.55451 7.31456 7.44855 7.20859L6.86789 6.62794C6.84727 6.60731 6.82346 6.59015 6.79737 6.57711L6.16455 6.2607C6.06009 6.20847 5.93392 6.22894 5.85134 6.31153L5.43394 6.72892C5.32798 6.83489 5.32798 7.00669 5.43394 7.11266L8.88755 10.5663C8.99351 10.6722 9.16532 10.6722 9.27128 10.5663L9.68868 10.1489C9.77126 10.0663 9.79174 9.94011 9.7395 9.83565L9.42309 9.20283C9.41005 9.17675 9.39289 9.15293 9.37227 9.13231L8.79161 8.55166C8.68565 8.44569 8.68565 8.27389 8.79161 8.16792L10.8062 6.15332C10.9122 6.04736 11.084 6.04736 11.1899 6.15332L11.7655 6.72892C11.8715 6.83489 12.0433 6.83489 12.1493 6.72892L13.4506 5.42578Z"
                                :fill="[
                                  comment.order_comments__fixed
                                    ? 'white'
                                    : '#31303D'
                                ]" />
                            </svg>
                          </div>
                          <div
                            class="comment-actions__delete d-flex justify-content-center align-items-center cursor-pointer"
                            @click="delComment(comment.order_comments__id)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                              fill="none">
                              <path
                                d="M2.66983 1.70071C2.40222 1.4331 1.96833 1.4331 1.70071 1.70071C1.4331 1.96833 1.4331 2.40222 1.70071 2.66983L7.03088 8L1.70071 13.3302C1.4331 13.5978 1.4331 14.0317 1.70071 14.2993C1.96833 14.5669 2.40222 14.5669 2.66983 14.2993L8 8.96912L13.3301 14.2992C13.5977 14.5668 14.0316 14.5668 14.2992 14.2992C14.5668 14.0316 14.5668 13.5977 14.2992 13.3301L8.96912 8L14.2993 2.66983C14.5669 2.40222 14.5669 1.96833 14.2993 1.70071C14.0317 1.4331 13.5978 1.4331 13.3302 1.70071L8 7.03088L2.66983 1.70071Z"
                                fill="black" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </BaseScrollbar>
              </div>
            </div>
          </div>
          <div class="d-flex gap-15 justify-content-end">
            <div class="flex-grow-1">
                <div class="bg-danger px-15 py-5 h-100" v-if="dataForModal.blacklist_notification"
                :style="{ 'max-width': !dataForModal.order_ext__is_owner ? '402.5px' : '' }">
                <span class="fsc-12 text-white spec-new-link-white" v-html="dataForModal.blacklist_notification"></span>
              </div>
            </div>
            <div class="d-flex gap-10">
              <div class="base-button base-button--action py-10 px-30 text-uppercase"
                :style="{ pointerEvents: phoneLookupLoading ? 'none' : '', opacity: phoneLookupLoading ? 0.6 : '' }"
                @click="() => { if (!phoneLookupLoading) { $modal.hide('ordersModal') } }">
                <span class="fsc-14">{{
                  dataLang['orders_model_edit__btn_text5']
                }}</span>
              </div>
              <div class="base-button base-button--action py-10 px-30 text-uppercase"
                :style="{ pointerEvents: phoneLookupLoading ? 'none' : '', opacity: phoneLookupLoading ? 0.6 : '' }"
                @click="sendData">
                <span class="fsc-14">{{
                  dataLang['orders_model_edit__btn_text6']
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BaseModal name="selectDateForDeferredOrder" width="420" :clickToClose="false" :shiftY="0.5" @before-close="
        () => {
          dateForDeferredOrder = []
        }
      " :adaptive="true" height="auto" classes="bg-transparent shadow-none">
        <div class="modal-base-content modal-content py-20 px-30 rounded-25 bg-white" :style="{}">
          <div class="d-flex justify-content-end">
            <slot name="modal-header"></slot>
            <button type="button" class="btn-close" @click="$modal.hide('selectDateForDeferredOrder')"></button>
          </div>
          <div
            class="modal-content-dynamic flex-grow-1 d-flex flex-column h-100 align-items-center justify-content-center container-with-input">
            <p class="fw-bold mb-30 text-center">
              {{ dataLang['orders_model_edit__btn_text3'] }}
            </p>
            <div class="d-flex gap-10 justify-content-between align-items-center mb-10">
              <BaseDatePicker v-model="dateForDeferredOrder" type="datetime" class="fsc-11 idiots-class-for-input-date"
                lang="ru" style="width: 200px" value-type="format" :disabled-date="notBeforeToday"
                :format="`${userSetting.company__tempalte_date} ${userSetting.company__tempalte_time}`"
                @change="(date) => (dateForDeferredOrder = date)"></BaseDatePicker>
            </div>
            <div class="d-flex flex-column align-items-center">
              <div class="d-flex justify-content-end gap-15">
                <div @click="$modal.hide('selectDateForDeferredOrder')"
                  class="btn btn-sm btn-opposite px-20 rounded-10 d-flex align-items-center justify-content-center">
                  {{ dataLang['vehile_modal_btn_reset'] }}
                </div>
                <div @click="orderDeferred('date', dateForDeferredOrder)"
                  class="btn btn-sm btn-primary action-hover px-20 rounded-10 d-flex align-items-center justify-content-center">
                  {{ dataLang['vehile_modal_btn_save'] }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </BaseModal>
    </div>
  </BaseModal>
</template>
<style lang="scss" scoped>
.special-box {
  position: relative;
  z-index: 5;

  &::before {
    content: '';
    display: block;
    background: #23b14d;
    position: absolute;
    top: 0;
    bottom: 0;
    left: -20px;
    right: -20px;
  }
}

.comments-base {
  padding-right: 15px;
}

.comment {
  padding: 6px 10px;
}

.comment-actions {
  gap: 2px;
}

.comment-actions>* {
  width: 16px;
  height: 16px;
}

.comment-actions__pin--active {
  background-color: green;
}

.is-overlay {
  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 20;
    width: 100%;
    height: 100%;
    background-color: rgba($color: white, $alpha: 0.5);
  }
}

.specal-button {
  background: linear-gradient(180deg,
      rgba(93, 92, 92, 0.2) 19.38%,
      rgba(215, 215, 215, 0.179815) 100%),
    linear-gradient(0deg, #ededed, #ededed),
    linear-gradient(0deg, #ffffff, #ffffff);
  min-height: 27px;
  height: 27px;
  min-width: 27px;
  display: flex;
}

.spec-new-link-white a {
  text-decoration: underline;
  color: white !important;
}
</style>
<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import GeneralService from '@/api/GeneralService'
import SelectsService from '@/api/SelectsService.js'
import EventBus from '@/event-bus.js'
export default {
  components: {},

  props: {
    currentOpenedId: {
      type: Number
    }
  },
  data() {
    return {
      isLoadWithoutClear: false,
      disableTypeClient: false,
      rawDate: {
        start: '',
        end: ''
      },
      clientName: '',
      clientPhone: '',
      phoneLookupLoading: false,
      finishCost: 0,
      timeout: null,
      dataForDatePicker: {
        orders__starts: [],
        orders__ends: []
      },
      dateForDeferredOrder: [],
      updatedValues: {},
      dataForModal: {},
      mainInfo: {},
      objectID: null,
      fullname: '',
      newCommentValue: {},
      loadingsStateComponent: {
        comment: false,
        deferred: false,
        main: false
      },
      modalInfo: {
        mode: 'create',
        modalOpened: false,
        id: null,
        loading: true
      },
      senderSmsPreset: {},
      selectsOptions: {
        car_body_type: [],
        orders__type_rent: [],
        presets: [],
        ads: [],
        objects_types: [],
        cities: []
      },
      dataFromSelect: {
        orders__type_rent: [],
        ads: [],
        objects_types: [],
        orders__body_generation: [],
        loadingsStateComponent: [],
        cities__end_name: [],
        cities__start_name: [],
        sms_presets: [],
        client: []
      },
      commentsList: [],
      diffByDate: 0,
      lastValueClients__phone: null
    }
  },
  methods: {
    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0))
    },
    notBeforeStart(date) {
      if (this.rawDate.orders__starts) {
        return date < this.$time(this.rawDate.orders__starts)
      } else if (this.dataForModal.orders__starts) {
        return date < this.$time(this.dataForModal.orders__starts)
      }
    },
    async sendData(additional, paramId) {
      if (this.phoneLookupLoading) {
        this.$toast.info('Дождитесь загрузки данных клиента')
        return
      }
      this.modalInfo.loading = true
      if (this.modalInfo.mode == 'create') {
        if (this.updatedValues.clients__phone) {
          return GeneralService.editOrCreate(`/orders`, this.updatedValues)
            .then((data) => {
              this.$toast.success(data.data.message)

              EventBus.$emit('updateContentData')
              this.$modal.hide('ordersModal')
            })
            .catch((e) => {

              this.$toast.error(e.response.data.message, { duration: 5000 })

              let errors = e.response.data.errors

              Object.keys(errors).forEach((e) => {
                this.$toast.error(errors[e][0], { duration: 5000 })
              })

            }).finally(() => {
              this.modalInfo.loading = false
            })
        } else {
          this.modalInfo.loading = false
          this.$toast.error('Заполните поле "Тел. клиента"', { duration: 5000 })
        }
      } else {
        return GeneralService.edit(
          `/orders/${this.modalInfo.id}`,
          Object.assign(this.updatedValues, {
            ...(additional && {
              set_action: additional
            })
          })
        )
          .then((data) => {
            this.$toast.success(data.data.message)
            EventBus.$emit('updateContentData')
            this.$modal.hide('ordersModal')

            if (paramId) {
              EventBus.$emit('reopenModal', { id: paramId, mode: 'edit' })
            }
            if (additional == 'order_ext__action_contract') {
              this.$router.push({
                path: '/contracts',
                query: { id: data.data.data.contractId }
              })
            }
          })
          .catch((e) => {
            Object.keys(e.response.data.errors).forEach((elem, index) => {
              if (this.$refs[elem]) {
                this.$refs[elem].classList.add('input-error')
              }
            })
            this.$toast.error(e.response.data.message, { duration: 5000 })

            let errors = e.response.data.errors

            Object.keys(errors).forEach((e) => {
              this.$toast.error(errors[e][0], { duration: 5000 })
            })
          }).finally(() => {
            this.modalInfo.loading = false
          })
      }
    },
    beforeOpen(data) {
      this.modalInfo.mode = data.params.mode
      this.modalInfo.modalOpened = true
      this.modalInfo.id = data.params?.id
      this.modalInfo.loading = true
      this.loadGlobalData()
    },
    orderDeferred(time, date) {
      this.loadingsStateComponent.deferred = true
      GeneralService.edit(`/orders/${this.modalInfo.id}`, {
        orders__status_id: 8,
        order_deferred_date_by: time,
        ...(date && {
          order_deferred_date_by_mod: this.$time(
            date,
            `${this.userSetting.company__tempalte_date} ${this.userSetting.company__tempalte_time}`
          )
            .utc(true)
            .utcOffset(Number(this.userSetting.company__utc))
            .format(`YYYY-MM-DD HH:mm:ss`)
        })
      })
        .then((data) => {
          this.$toast.success(data.data.message)
          this.$modal.hide('selectDateForDeferredOrder')
          this.$modal.hide('ordersModal')

          this.dateForDeferredOrder = []
          this.$emit('updateMainData')
          this.loadingsStateComponent.deferred = false
        })
        .catch((e) => {
          this.$toast.error(e.response.data.message, { duration: 5000 })
        })
    },
    loadComments() {
      this.loadingsStateComponent.comment = true
      GeneralService.get(`/orders/${this.modalInfo.id}/comments`)
        .then((data) => {
          this.commentsList = data.data.data.rows
          this.loadingsStateComponent.comment = false
        })
        .catch((e) => { })
    },
    sendSms() {
      if (
        (this.dataForModal.clients__phone ||
          this.updatedValues.clients__phone) &&
        Object.values(this.senderSmsPreset).length
      ) {
        this.loadingsStateComponent.deferred = true

        GeneralService.editOrCreate(`/sms`, {
          phone:
            this.dataForModal.clients__phone ||
            this.updatedValues.clients__phone,
          text: this.senderSmsPreset.sms_presets__text,
          "type": "order",
          "id": this.modalInfo.id,
          preset: this.senderSmsPreset.sms_presets__name,
        })
          .then((data) => {
            // this.selects.push(data.data.data.rows)
            this.$toast.success(data.data.message)
            this.loadComments()
            this.dataFromSelect.sms_presets = []
            this.senderSmsPreset = {}
            this.loadingsStateComponent.deferred = false
          })
          .catch((e) => {
            if (e?.response?.data) {
              this.$toast.error(e?.response.data.message, { duration: 5000 })
            }
            this.loadingsStateComponent.deferred = false
          })
      } else {
        this.$toast.error('Не введен номер телефона или не выбран пресет', { duration: 5000 })
      }
    },
    delComment(id) {
      GeneralService.delete(`/orders/${this.modalInfo.id}/comments/${id}`)
        .then((data) => {
          // this.selects.push(data.data.data.rows)
          this.$toast.success(data.data.message)
          this.loadingsStateComponent.comment = false
          this.loadComments()
        })
        .catch((e) => { })
    },
    fixComment(id, fix) {
      GeneralService.edit(`/orders/${this.modalInfo.id}/comments/${id}`, {
        order_comments__fixed: fix
      })
        .then((data) => {
          // this.selects.push(data.data.data.rows)
          this.$toast.success(data.data.message)
          this.loadingsStateComponent.comment = false
          this.loadComments()
          this.newCommentValue = {}
        })
        .catch((e) => { })
    },
    sendComment() {
      if (this.newCommentValue?.value) {
        this.loadingsStateComponent.comment = true
        GeneralService.editOrCreate(`/orders/${this.modalInfo.id}/comments`, {
          order_comments__comment: this.newCommentValue.value
        })
          .then((data) => {
            // this.selects.push(data.data.data.rows)
            this.$toast.success(data.data.message)
            this.loadingsStateComponent.comment = false
            this.loadComments()
            this.newCommentValue = {}

            this.$refs.commentInput.$el.querySelector('input').value = ''
          })
          .catch((e) => { })
      } else {
        this.$toast.error('Напишите комментарий', { duration: 5000 })
      }
    },
    beforeClose() {
      this.updatedValues = {}
      this.dataForModal = {}
      this.modalInfo.modalOpened = false
      for (const key in this.dataFromSelect) {
        this.dataFromSelect[key] = []
      }
      this.dateForDeferredOrder = []
      for (const key in this.dataForDatePicker) {
        this.dataForDatePicker[key] = []
      }
      this.clientName = ''
      this.finishCost = 0
      this.diffByDate = 0
      this.fullname = ''
      this.modalInfo.loading = true
      this.lastValueClients__phone = null
    },
    updateValue(data) {
      this.updatedValues[data.name] = data.value
      if (this.$refs[data.name]) {
        this.$refs[data.name].classList.remove('input-error')
      }
      if (data.name == 'clients__phone') {
        this.dataForModal.clients__phone = data.value

        if(data.value.length==16 && this.lastValueClients__phone!=data.value){
          this.lastValueClients__phone = data.value
          this.findClientInfo(data.value)
        }
        // clearTimeout(this.timeout)
        // this.timeout = setTimeout(() => {
        //   this.isLoadWithoutClear = true
        //   this.findClientInfo(data.value)
        // }, 2000)
      }
    },
    findClientInfo(phone) {
      if (!phone) {
        this.phoneLookupLoading = false
        this.modalInfo.loading = false
        return
      }
      this.phoneLookupLoading = true
      this.modalInfo.loading = true

      GeneralService.get(`/clients?where=[{"field":"clients__phone","value": "${phone}","mod":"phone"}, {"field":"clients__company_id","value": ${this.userSetting.company_lc}}]&joins=verifications,client_status`)
        .then((data) => {
          if (data.data.data.rows.length) {
            this.clientName = data.data.data.rows[0].clients__name
            this.updatedValues.clients__name =
              data.data.data.rows[0].clients__name
            this.disableTypeClient = true

            if (data.data.data.rows[0].clients__is_ur_face) {
              this.dataFromSelect.client = {
                label: this.selectsOptions.clients_types_face[1].label
              }
            } else {
              this.dataFromSelect.client = {
                label: this.selectsOptions.clients_types_face[0].label
              }
            }

          } else {
            this.clientName = ''
            this.updatedValues.clients__name = ''
            this.$toast.warning('Клиент не найден')
            this.disableTypeClient = false
            this.dataFromSelect.client = {
              label: ''
            }
          }
        })
        .catch((e) => {
          this.$toast.error(e.response.data.message, { duration: 5000 })
        }).finally(() => {
          this.phoneLookupLoading = false
          this.modalInfo.loading = false
        })
    },
    async changeDate(date, nameField) {
      if (this.$refs[nameField]) {
        this.$refs[nameField].classList.remove('input-error')
      }
      const newDate = new Date(date)
      this.updatedValues[nameField] = this.$time(newDate).format('YYYY-MM-DD HH:mm:ss')
      this.dataForModal[nameField] = date
      this.rawDate[nameField] = newDate
      if (nameField == 'orders__starts') {
        const newDate = new Date(date)
        this.updatedValues['orders__ends'] = this.$time(newDate).set('hour', 12).set('minute', 0).set('second', 0).add(3, 'day').format('YYYY-MM-DD HH:mm:ss')
        this.dataForModal['orders__ends'] = this.$time(newDate).set('hour', 12).set('minute', 0).set('second', 0).add(3, 'day').format('YYYY-MM-DD HH:mm:ss')
        this.rawDate['orders__ends'] = this.$time(newDate).set('hour', 12).set('minute', 0).set('second', 0).add(3, 'day').format('YYYY-MM-DD HH:mm:ss')
        this.dataForDatePicker.orders__ends = new Date(this.$time(newDate).set('hour', 12).set('minute', 0).set('second', 0).add(3, 'day'))
      }
      if (
        this.rawDate.orders__ends &&
        this.rawDate.orders__starts &&
        (this.updatedValues.orders__start_city_id ||
          this.dataForModal.orders__start_city_id) &&
        (this.updatedValues.orders__end_city_id ||
          this.dataForModal.orders__end_city_id)
      ) {
        await this.loadCalculate()
      }
    },
    loadCalculate(isSave) {
      this.modalInfo.loading = true
      return GeneralService.edit(`/orders/calculate`, {
        orders__type_rent: this.dataForModal.orders__type_rent ||
          this.updatedValues.orders__type_rent,
        orders__vehicle_id:
          this.dataForModal.orders__vehicle_id ||
          this.updatedValues.orders__vehicle_id,
        orders__starts: this.$time(this.rawDate['orders__starts']).format('YYYY-MM-DD HH:mm:ss'),
        orders__ends: this.$time(this.rawDate['orders__ends']).format('YYYY-MM-DD HH:mm:ss'),
        orders__start_city_id:
          this.updatedValues.orders__start_city_id ||
          this.dataForModal.orders__start_city_id,
        orders__end_city_id:
          this.updatedValues.orders__end_city_id ||
          this.dataForModal.orders__end_city_id,
        order_ext__ad_id: this.updatedValues.order_ext__ad_id ||
          this.dataForModal.order_ext__ad_id,
        orders__body_generation: this.updatedValues.orders__body_generation ||
          this.dataForModal.orders__body_generation,
        orders__vehicle_name: this.updatedValues.orders__vehicle_name ||
          this.dataForModal.orders__vehicle_name,
        orders__vehicle_type: this.updatedValues.orders__vehicle_type ||
          this.dataForModal.orders__vehicle_type
      })
        .then(async (data) => {
          if (
            (this.dataForModal.orders__vehicle_id ||
              this.updatedValues.orders__vehicle_id) &&
            (this.updatedValues.orders__ends || this.dataForModal.orders__ends)
          ) {

            if (Object.keys(data.data.data.orders__vehicle).length) {
              let middleResponse = data.data.data.orders__vehicle
              this.fullname = `${middleResponse?.vehicles__name} ${middleResponse?.vehicles__gosnumber ? '<br/>' : ''
                }  ${middleResponse?.vehicles__gosnumber}`
            }
          }
          this.diffByDate = data.data.data.orders__duration
          this.finishCost = data.data.data.orders__cost
          if (isSave) {
            await this.sendData(
              null, this.dataForModal.orders__id
            )
          }
        })
        .catch((e) => {
          if (e.response) {
            this.$toast.error(e.response.data.message, { duration: 5000 })
            Object.keys(e.response.data.errors).forEach((elem) => {
              if (this.$refs[elem]) {
                this.$refs[elem].classList.add('input-error')
              }
            })
          }
        }).finally(() => {
          this.modalInfo.loading = false
        })
    },
    loadGlobalData() {
      Promise.all([
        SelectsService.getAll().then((data) => {
          this.selectsOptions = Object.assign(
            this.selectsOptions,
            this.prepareLabelsForDefaultSelects(
              data.data.data.rows,
              'allSelects',
              true
            )
          )
        }),
        GeneralService.get(`/ads`)
          .then((data) => {
            this.selectsOptions.ads = data.data.data.rows
          })
          .catch((e) => { }),
        GeneralService.get(`/objects/types`)
          .then((data) => {
            this.selectsOptions.objects_types = data.data.data.rows
          })
          .catch((e) => { }),
        GeneralService.get(`/cities`, {
          params: {
            limit: 2000
          }
        })
          .then((data) => {
            this.selectsOptions.cities = data.data.data.rows
          })
          .catch((e) => { })
      ]).then(() => {
        if (this.modalInfo.mode == 'edit') {
          Promise.all([
            GeneralService.get(`/orders/${this.modalInfo.id}/comments`)
              .then((data) => {
                this.commentsList = data.data.data.rows
              })
              .catch((e) => { }),
            GeneralService.get(`/orders/${this.modalInfo.id}?joins=clients,vehicles,ads,verifications,client_status,black_list`)
              .then(async (data) => {
                GeneralService.get(`/orders/${this.modalInfo.id}/title`)
                  .then((data) => {
                    // this.selects.push(data.data.data.rows)
                    this.mainInfo = data.data.data.rows[0]
                  })
                  .catch((e) => { })
                this.dataForModal = data.data.data.rows[0]
                if (this.dataForModal.orders__vehicle_id) {
                  GeneralService.get(
                    `/objects?fields=vehicles__id,vehicles__name,vehicles__gosnumber,vehicles__is_own&open=true&where=[{"field":"vehicles__id","value":${this.dataForModal.orders__vehicle_id}}]`
                  )
                    .then((data) => {
                      if (!data.data.data.rows.length) {
                      } else {
                        this.dataForModal.vehicles__gosnumber =
                          data.data.data.rows[0].vehicles__gosnumber
                        setTimeout(() => {
                          this.fullname = `${data.data.data.rows[0].vehicles__name
                            } ${data.data.data.rows[0].vehicles__gosnumber
                              ? '<br/>'
                              : ''
                            }  ${data.data.data.rows[0].vehicles__gosnumber}`
                        }, 1)
                      }
                    })
                    .catch((e) => {
                      this.$toast.error(e.response.data.message, { duration: 5000 })
                    })
                }

                this.dataFromSelect.ads = {
                  ads__name: this.dataForModal.ads__name
                }

                this.clientName = this.dataForModal.clients__name
                this.finishCost = this.dataForModal.orders__cost

                this.dataFromSelect.orders__type_rent = {
                  label: this.dataLang[this.dataForModal.orders__type_rent]
                }
                this.dataFromSelect.orders__body_generation = {
                  vehicles_body_generation__body_generation:
                    this.dataForModal.orders__body_generation
                }
                this.dataFromSelect.cities__start_name = this.selectsOptions.cities.find((x) => x.cities__id == this.dataForModal.orders__start_city_id)
                this.dataFromSelect.cities__end_name = this.selectsOptions.cities.find((x) => x.cities__id == this.dataForModal.orders__end_city_id)

                if (
                  this.dataForModal.orders__ends &&
                  this.dataForModal.orders__starts
                ) {
                  this.diffByDate = this.dataForModal.orders__duration
                }

                this.dataFromSelect.objects_types = this.selectsOptions.objects_types.find((x) => x.vehicle_types__code == this.dataForModal.orders__vehicle_type)

                this.rawDate.orders__starts = new Date(
                  this.dataForModal.orders__starts
                )

                this.rawDate.orders__ends = new Date(
                  this.dataForModal.orders__ends
                )

                this.dataForDatePicker = {
                  orders__ends: new Date(this.dataForModal.orders__ends),
                  orders__starts: new Date(this.dataForModal.orders__starts)
                }
                this.loadCalculate()
              })
              .catch((e) => { }),
            GeneralService.get(`/presets/sms`, {
              params: {
                where: JSON.stringify([
                  { field: 'sms_presets__category_id', value: 1 }
                ])
              }
            })
              .then((data) => {
                this.selectsOptions.presets = data.data.data.rows
              })
              .catch((e) => { })
          ]).then(() => {


            this.objectID = this.dataForModal.orders__vehicle_id

            // this.$refs.objectName.textContent =
            //   this.dataForModal.vehicles__name +
            //   ' ' +
            //   this.dataForModal.vehicles__gosnumber
          })
        }

        GeneralService.get('/whoami')
          .then(async (who) => {
            if (!this.dataForModal.cities__start_name && !this.dataForModal.cities__end_name) {
              this.dataFromSelect.cities__start_name =
                this.selectsOptions.cities.find(
                  (x) =>
                    x.cities__id == who.data.data.company_default_city_id
                )
              this.dataFromSelect.cities__end_name =
                this.selectsOptions.cities.find(
                  (x) => x.cities__id == who.data.data.company_default_city_id
                )

              this.updatedValues.orders__start_city_id =
                this.selectsOptions.cities.find(
                  (x) =>
                    x.cities__id == who.data.data.company_default_city_id
                ).cities__id
              this.updatedValues.orders__end_city_id =
                this.selectsOptions.cities.find(
                  (x) => x.cities__id == who.data.data.company_default_city_id
                ).cities__id
            }

            if (!this.dataForModal.orders__starts && !this.dataForModal.orders__ends) {

              let start = this.$time().set('hour', 12).set('minute', 0).set('second', 0)
                .format(
                  `${this.userSetting.company__tempalte_date} ${this.userSetting.company__tempalte_time}`
                )
              let end = this.$time().set('hour', 12).set('minute', 0).add(3, 'day').set('second', 0)
                .format(
                  `${this.userSetting.company__tempalte_date} ${this.userSetting.company__tempalte_time}`
                )

              this.rawDate.orders__starts = this.$time().set('hour', 12).set('minute', 0).set('second', 0).format('YYYY-MM-DD HH:mm:ss')
              this.rawDate.orders__ends = this.$time().set('hour', 12).set('minute', 0).set('second', 0).add(3, 'day').format('YYYY-MM-DD HH:mm:ss')

              this.dataForDatePicker = {
                orders__starts: new Date(this.$time().set('hour', 12).set('minute', 0).set('second', 0)),
                orders__ends: new Date(this.$time().set('hour', 12).set('minute', 0).set('second', 0).add(3, 'day'))
              }

              this.updatedValues.orders__starts = this.$time().set('hour', 12).set('minute', 0).set('second', 0).format('YYYY-MM-DD HH:mm:ss')
              this.updatedValues.orders__ends = this.$time().set('hour', 12).set('minute', 0).set('second', 0).add(3, 'day').format('YYYY-MM-DD HH:mm:ss')

              await this.loadCalculate()
            }
          })
          .catch((e) => {
            console.log(e)
          });
      });
    },
    async setSimpleSelect(data, name) {
      if (this.$refs[name]) {
        this.$refs[name].classList.remove('input-error')
      }
      this.updatedValues[name ?? data.key] = data.value
      delete this.updatedValues.clients_types_face
      if (name == 'orders__vehicle_type') {
        GeneralService.get(
          `/selects/body-generation/${data.fallback}?orderBy=vehicles_body_generation__position&orderDir=ASC`
        )
          .then((data) => {
            this.selectsOptions = Object.assign(this.selectsOptions, {
              car_body_type: data.data.data.rows
            })
          })
          .catch((e) => { })
      }
      if (data.key == 'clients_types_face') {
        this.updatedValues.clients__is_ur_face =
          data.value == 'clients_type_fiz' ? false : true
        this.dataForModal.clients__is_ur_face =
          data.value == 'clients_type_fiz' ? false : true
      }

      if (name == 'orders__end_city_id' || name == 'orders__start_city_id') {
        if (
          this.rawDate.orders__ends &&
          this.rawDate.orders__starts &&
          (this.updatedValues.orders__start_city_id ||
            this.dataForModal.orders__start_city_id) &&
          (this.updatedValues.orders__end_city_id ||
            this.dataForModal.orders__end_city_id)
        ) {
          await this.loadCalculate()
        }
      }

      if (this.$refs[data.key]) {
        this.$refs[data.key].classList.remove('input-error')
      }
    },
    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element['label'] = element[Object.keys(element).pop()]
          element['key'] = key
          element['value'] = Object.keys(element)[0]
          element['selectName'] = keyDataFromFetch
        })
      }
      return data
    },
    ...mapActions('transportVehiclesModule', ['getHealth', 'getTitle'])
  },
  computed: {
    ...mapState('translationModule', ['dataLang']),
    ...mapState('userSettingModule', ['userSetting'])
  }
}
</script>
